import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import radiator from "../../../assets/smarthome/heaterSection/radiateur.png";
import ac from "../../../assets/smarthome/heaterSection/ac.png";
import radiatorValve from "../../../assets/smarthome/heaterSection/teteThermostatique.png";

const features = [
  {
    name: "electricalRadiator",
    image: radiator,
  },
  {
    name: "radiatorValve",
    image: radiatorValve,
  },
  {
    name: "acSplit",
    image: ac,
  },
];

export default function HeatingSection(props) {
  const { textContent, language } = { ...props };
  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container heater">
      <div className="container-small heater">
        <h1 className="title-gradient-blue-red">
          {textContent.heatingSection.title[language]}
        </h1>
        <h2>{textContent.heatingSection.features.title[language]}</h2>
      </div>
      {/* <div className="container-empty-extra-small" /> */}
      <div className={`grid-3 heater ${isMobile ? "carousel" : ""}`}>
        {features.map((feature, index) => (
          <div className="heater-card" key={index}>
            {/* panneau blanc */}
            <div className="heater-card-panel">
              <h3 className="h3-bold">
                {
                  textContent.heatingSection.features.items[feature.name]
                    ?.title[language]
                }
              </h3>
              {isMobile || screenWidth > 1200 ? (
                <p>
                  {
                    textContent.heatingSection.features.items[feature.name]
                      ?.description[language]
                  }
                </p>
              ) : null}
            </div>

            {/* iPhone */}
            <div
              className={
                isMobile
                  ? "heater-card-phone mobileScreen"
                  : screenWidth < 1300
                    ? "heater-card-phone smallScreen"
                    : screenWidth < 1400
                      ? "heater-card-phone mediumScreen"
                      : screenWidth < 1700
                        ? "heater-card-phone largeScreen"
                        : "heater-card-phone extraLargeScreen"
              }
            >
              <img src={feature.image} alt="" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
